import myShipmentsLandingPagesResetPassword from './myShipmentsLandingPagesResetPassword';

export default myShipmentsLandingPagesResetPassword;
